import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Environment } from '../environments/environment';
import translateJson from "../translate.json";
import { EmployerType } from './shared/enum/EmployerType';

@Injectable()
export class AppService {

    // Get translation/text from customerJson
    private i18 = translateJson.i18;
    private employerType = EmployerType;

    constructor(private router: Router){}

    /**
     * Set route
     * @param routeLink route name
     */
    setRoute(routeLink): void {        
        this.router.navigate([routeLink]);
    }

    /**
     * Is component active
     * @param routeName route name of component 
     */
    isComponentActive(routeName) {
        for (let i = 0; i < Environment.components.length; i++) {
            if (Environment.components[i].routeName == routeName) {
                return Environment.components[i].active;
            }
        }
    }   

    /**
     * Return translated organisation type
     * @param orgType 
     * @returns 
     */
    getTranslatedOrgType(orgType: string) {
        if(orgType == this.employerType.GOVERNMENT) {
            return this.i18.organisation.form.organisationType1Label
        } else if(orgType == this.employerType.COUNTY) {
            return this.i18.organisation.form.organisationType2Label
        } else if(orgType == this.employerType.MUNICIPALITY) {
            return this.i18.organisation.form.organisationType3Label
        } else if(orgType == this.employerType.COMPANY) {
            return this.i18.organisation.form.organisationType4Label
        } else {
            return orgType;
        } 
    }

    /**
     * Get translated error message if exist
     * @param error 
     * @returns id and error message
     */
    getTranslatedErrorMessage(error: any): string {
        let errorMessage = error.split(":", 2); // Split by the first occurence of semicolonn

        if (errorMessage.length > 1) {
            let message = "ID: " + errorMessage[0] + ": ";
            for (let error of this.i18.errors) {
                for(var key in error) {
                    if (key === errorMessage[0]) {
                        return message += error[key];
                    }
                }    
            }
            return message += errorMessage[1];
        } else {
            return error;
        }        
    }

    /**
     * Get translated error message by error code
     * @param errorCode error code as string
     * @returns id and error message
     */
    getTranslatedErrorMessageFromArray(errorCode): string {
        let errorMsg = '';
        if(errorCode != null && errorCode > 0 && this.i18.errors.length > 0){
            this.i18.errors.forEach(error => {
                let key = Object.keys(error)
                if(key[0] === errorCode){
                    const errorKey = key[0] as keyof typeof error;
                    errorMsg = 'ID: ' + key + ': ' + error[errorKey];
                    return errorMsg;
                }
            });

            //if the translate.json is missing the error message
            if(errorMsg.length === 0){
                errorMsg = 'ID: 700: Landet finns inte med i listan'
                return errorMsg;
            }
        }
        return errorMsg;
    }

    /**
     * Method to get a translate value from translate.json
     * by the complete translate key string.
     * ex: i18.searchParams.selectables.headSupplier
     * @param translateName translate keystring
     * @param verboseName original verboseName for fallback
     * @returns corresponding value
     */
    getTranslateValueFromKeyStr(translateName: string, verboseName: string){
        let translatedParts = translateName.split('.');
        let translateValue = null;
        if(translatedParts.length > 0){
            translateValue = this.i18;
            translatedParts.forEach(s => {
                if(s != null) {
                    if(translateValue.hasOwnProperty(s)) {
                        translateValue = translateValue[s];
                    }
                }
            })
        }
        return translateValue != null && typeof translateValue === 'string' ? translateValue : verboseName;
    }

    /**
     * Scroll to taget Id in a HTML-page
     * @param target tag id
     */
    public scrollToTarget(target): void {
        if(document.getElementById(target) != null){
            document.getElementById(target).scrollIntoView({
                behavior: "smooth",
                block: "start",
                inline: "nearest"
            });
        }
    }

    /**
     * Scroll to taget Id in a HTML-page when ngAfterView is used (needed for scroll to search result anchor)
     * @param target tag id
     * returns Boolean
     */
    public scrollToTargetBoolean(target): boolean {
        if(document.getElementById(target) != null){
            document.getElementById(target).scrollIntoView({
                behavior: "auto",
                block: "nearest",
                inline: "nearest"
            });
            return true;
        }

        return false;
    }
}
